function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 0C2.23858 0 0 2.23858 0 5V15C0 15.3788 0.214002 15.725 0.552786 15.8944C0.89157 16.0638 1.29698 16.0273 1.6 15.8L4.8 13.4C5.14619 13.1404 5.56726 13 6 13H8C8 15.2091 9.79086 17 12 17H14.6667L18.4 19.8C18.703 20.0273 19.1084 20.0638 19.4472 19.8944C19.786 19.725 20 19.3788 20 19V11C20 8.79086 18.2091 7 16 7V5C16 2.23858 13.7614 0 11 0H5ZM14 8V5C14 3.34315 12.6569 2 11 2H5C3.34315 2 2 3.34315 2 5V12.5C2 12.706 2.23519 12.8236 2.4 12.7L3.6 11.8C4.29239 11.2807 5.13452 11 6 11H11C12.6569 11 14 9.65685 14 8ZM10 13H11C13.419 13 15.4367 11.2822 15.9 9H16C17.1046 9 18 9.89543 18 11V16.5C18 16.706 17.7648 16.8236 17.6 16.7L15.6 15.2C15.4269 15.0702 15.2164 15 15 15H12C10.8954 15 10 14.1046 10 13Z"
});

var SvgReadChat = function SvgReadChat(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#18B6FF"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/read-chat.6b54dfa8.svg";
export { SvgReadChat as ReactComponent };